import { render, staticRenderFns } from "./BannerAi.vue?vue&type=template&id=e2f9402c&scoped=true"
import script from "./BannerAi.vue?vue&type=script&lang=js"
export * from "./BannerAi.vue?vue&type=script&lang=js"
import style0 from "./BannerAi.vue?vue&type=style&index=0&id=e2f9402c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2f9402c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
